import axios from 'axios'

export const getAllApps = () => {
  return axios.get('/apps/user')
}

export const getFavoriteApps = () => {
  return axios.get('/favorite/app')
}

export const addFavoriteApp = ({ appId }) => {
  return axios.post('/favorite/app', { id: appId })
}

export const deleteFavoriteApp = ({ appId }) => {
  return axios.delete(`favorite/app?id=${appId}`)
}
